import { ReqPaginadoKanban } from "@/utils/Types/ReqPaginadoKanban";
import { api } from "./api";

export const updateLead = async (id: number, data: any) => {
  return api.patch(`/lead/update`, { id, data });
};

export async function create(data: any) {
  return await api.post(`/lead/create`, data);
}

export const get = async (archived? : boolean, atendente_id?: string) => {
  return api.get(`/lead/list`, {
    params: {
      arquivamento: archived ?? false,
      atendente_id,
    }
  });
};

export const getForGroup = async () => {
  return api.get(`/lead/listForGroup`);
};

export const getListOrigens = async (atendente_id?: string) => {
  return api.get(`/lead/listOrigens`, {
    params: {
      atendente_id,
    }
  });
};

export const buscarLeadPorId = async (id: string | number) => {
  return api.get(`/lead/buscarPorId/${id}`);
};

export const deleteLead = async (id: number) => {
  return api.delete(`/lead/delete`, { data: { id } });
};

export const getByEstagio = async (
  param : ReqPaginadoKanban
) => {
  return api.get(`/lead/listByEstagio`, { params: { 
    estagio : param.estagio, 
    arquivamento : param.arquivamento, 
    criadoEm : param.criadoEm, 
    startDate : param.startDate,
    endDate : param.endDate,
    pagina : param.pagina, 
    quantidade : param.quantidade, 
    searchTerm : param.searchTerm, 
    atendentes: param.atendentes?.toString() 
  } });
}

export const leadApi = {
  updateLead,
  create,
  get,
  getForGroup,
  deleteLead,
  getListOrigens,
  buscarLeadPorId,
  getByEstagio
};
